import React, { useEffect, useState } from "react";
import "./RegisterOrganization.css"; // Import the updated CSS
import { Footer, Header } from "./basicComponent/Basic";
import axios from "axios";
import { url, localUrl } from "../BaseUrl";
const RegisterOrganization = () => {
  const [organizationName, setOrganizationName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [address, setAddress] = useState({
    street: "",
    city: "",
    state: "",
    zip: "",
    country: "",
  });
  const [adminFirstName, setAdminFirstName] = useState("");
  const [adminLastName, setAdminLastName] = useState("");
  const [adminEmail, setAdminEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [postofficeBranch,setpostofficeBranch]=useState([])
   // Add success message state
  const pinCodeAPi = async (pincode) => {
    try {
      const pinCodedata = await axios.get(
        `https://api.postalpincode.in/pincode/${address.zip}`
      );
      setpostofficeBranch(pinCodedata?.data[0].PostOffice);
      // pinCodedata?.data[0].PostOffice==null ?"": pinCodedata?.data[0].PostOffice;
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const [selectedLocation, setSelectedLocation] = useState("");
  const [selectPostoffice,setSelectpostOffice]=useState()
 
  const POSTOFFICEBRANCHNAME= async (POSTOFFICEBRANCHNAME)=>{
    const postOffice=await axios.get(`https://api.postalpincode.in/postoffice/${POSTOFFICEBRANCHNAME}`)
    setSelectpostOffice(postOffice.data[0].PostOffice[0])




  }
  // Handle change in selection
  const handleChange = (event) => {
    setSelectedLocation(event.target.value);
    POSTOFFICEBRANCHNAME(event.target.value)
  };
  const handleAddressChange = (e) => {
    setAddress({
      ...address,
      [e.target.name]: e.target.value,
    });

    pinCodeAPi();
  };

  const handleSubmit = async () => {
    setAddress({
      street: selectPostoffice?.Name,
      city: selectPostoffice?.District,
      state: selectPostoffice?.State,
      zip: selectPostoffice?.Pincode,
      country: selectPostoffice?.Country,
      
    });
    setErrorMessage("");
    setSuccessMessage(""); // Reset success message

    // Validation checks
    if (password !== confirmPassword) {
      setErrorMessage("Passwords do not match!");
      return;
    }

    if (
      !organizationName ||
      !phoneNumber ||
      !adminFirstName ||
      !adminLastName ||
      !adminEmail ||
      !password
    ) {
      setErrorMessage("All fields are required!");
      return;
    }

    const organizationData = {
      organizationName,
      phoneNumber,
      address,
      adminFirstName,
      adminLastName,
      adminEmail,
      password,
    };

    try {
      // const response = await fetch('/register-organization', {
      //   method: 'POST',
      //   headers: {
      //     'Content-Type': 'application/json',
      //   },
      //   body: JSON.stringify(organizationData),
      // });
      const response = await axios.post(
        `${url}/api/auth/OrganizationRegister`,
        organizationData
      );
      if (response) {
        // Set success message and clear the form fields
        setSuccessMessage("Organization registered successfully!");
        setOrganizationName("");
        setPhoneNumber("");
        // setAddress({
        //   street: "",
        //   city: "",
        //   state: "",
        //   zip: "",
        //   country: "",
        // });
        setAdminFirstName("");
        setAdminLastName("");
        setAdminEmail("");
        setPassword("");
        setConfirmPassword("");
      } else {
        setErrorMessage("Error registering organization. Please try again.");
      }
    } catch (error) {
      setErrorMessage("An error occurred. Please try again.");
    }
  };


  return (
    <>
      <Header />
      <div className="register-container">
        <h2>Register Your Organization</h2>

        {errorMessage && <p className="error-message">{errorMessage}</p>}
        {successMessage && <p className="success-message">{successMessage}</p>}

        <div className="form-group">
          <label htmlFor="organizationName">Organization Name</label>
          <input
            id="organizationName"
            type="text"
            placeholder="Enter Organization Name"
            value={organizationName}
            onChange={(e) => setOrganizationName(e.target.value)}
            className={`form-input ${organizationName ? "" : "input-error"}`}
          />
        </div>
        <div className="form-group">
          <label htmlFor="phoneNumber">Phone Number</label>
          <input
            id="phoneNumber"
            type="text"
            placeholder="Enter Phone Number"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
            className={`form-input ${phoneNumber ? "" : "input-error"}`}
          />
        </div>

        <fieldset className="address-group">
          <legend>Address</legend>
          <div className="form-group">
            <label htmlFor="zip">ZIP/Postal Code</label>
            <input
              id="zip"
              type="text"
              name="zip"
              placeholder="Enter ZIP/Postal Code"
              maxLength={12}
              onChange={handleAddressChange}
              className="form-input"
            />
          </div>
          <div className="form-group">
            <label>Select a Location:</label>
            <select
              id="location-select"
              value={selectedLocation}
              onChange={handleChange}
            >
              <option value="">None</option>
              {postofficeBranch && postofficeBranch.length > 0 ? (
                postofficeBranch?.map((location, index) => (
                  <option key={index} value={location?.Name}>
                    {location?.Name}
                  </option>
                ))
              ) : (
                <option value="" disabled>
                  No locations available
                </option>
              )}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="street">Street Address</label>
            <input
              id="street"
              type="text"
              name="street"
              placeholder="Enter Street Address"
              value={selectPostoffice?.Name }
              onChange={handleAddressChange}
              className="form-input"
            />
          </div>
          <div className="form-group">
            <label htmlFor="city">City</label>
            <input
              id="city"
              type="text"
              name="city"
              placeholder="Enter City"
              value={selectPostoffice?.District}
              onChange={handleAddressChange}
              className="form-input"
            />
          </div>
          <div className="form-group">
            <label htmlFor="state">State/Province</label>
            <input
              id="state"
              type="text"
              name="state"
              placeholder="Enter State/Province"
              value={selectPostoffice?.State}
              onChange={handleAddressChange}
              className="form-input"
            />
          </div>
          <div className="form-group">
            <label htmlFor="country">Country</label>
            <input
              id="country"
              type="text"
              name="country"
              placeholder="Enter Country"
              value={selectPostoffice?.Country}
              onChange={handleAddressChange}
              className="form-input"
            />
          </div>
        </fieldset>

        <div className="form-group">
          <label htmlFor="adminFirstName">Admin First Name</label>
          <input
            id="adminFirstName"
            type="text"
            placeholder="Enter Admin First Name"
            value={adminFirstName}
            onChange={(e) => setAdminFirstName(e.target.value)}
            className={`form-input ${adminFirstName ? "" : "input-error"}`}
          />
        </div>
        <div className="form-group">
          <label htmlFor="adminLastName">Admin Last Name</label>
          <input
            id="adminLastName"
            type="text"
            placeholder="Enter Admin Last Name"
            value={adminLastName}
            onChange={(e) => setAdminLastName(e.target.value)}
            className={`form-input ${adminLastName ? "" : "input-error"}`}
          />
        </div>
        <div className="form-group">
          <label htmlFor="adminEmail">Admin Email</label>
          <input
            id="adminEmail"
            type="email"
            placeholder="Enter Admin Email"
            value={adminEmail}
            onChange={(e) => setAdminEmail(e.target.value)}
            className={`form-input ${adminEmail ? "" : "input-error"}`}
          />
        </div>
        <div className="form-group">
          <label htmlFor="password">Password</label>
          <input
            id="password"
            type="password"
            placeholder="Enter Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className={`form-input ${password ? "" : "input-error"}`}
          />
        </div>
        <div className="form-group">
          <label htmlFor="confirmPassword">Confirm Password</label>
          <input
            id="confirmPassword"
            type="password"
            placeholder="Confirm Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            className={`form-input ${confirmPassword ? "" : "input-error"}`}
          />
        </div>

        <button className="submit-btn" onClick={handleSubmit}>
          Register
        </button>
      </div>
      <Footer />
    </>
  );
};

export default RegisterOrganization;
